const ROUTES = {
  ROOT:            "/",

  // Auth Routes
  LOGIN:           "/login",
  LOGOUT:          "/logout",

  // Drawer Routes
  DASHBOARD:       "/dashboard",
  ANALYTICS:       "/analytics",
  DEALER:          "/dealer-management",
  ORDERS:          "/orders",
  INVENTORY:       "/inventory",
  VEHICLES:        "/inventory/vehicles",
  BATTERIES:       "/inventory/batteries",
  ADDVEHICLE:      "/inventory/vehicles/addvehicle",
  ADDBATTERY:      "/inventory/batteries/addbattery",
  BATTERY_DETAIL:  "/inventory/batteries/:bId",
  VEHICLE_DETAIL:  "/inventory/vehicles/:vId",
  ADDCLIENT:       "/lease/addclient",
  SETTINGS:        "/settings",
  PROFILE:         "/settings/profile",
  CHANGE_PASSWORD: "/settings/change-password",
  MODELS:          "/settings/models",
  CLIENTS:         "/settings/clients",
  ADDMODEL:        "/settings/models/add",
  NOTIFICATIONS:   "/notifications",
  LEASE:           "/lease",
  LEASED_VEHICLES: "/lease/vehicles",
  LEASE_VEHICLES:  "/lease/vehicles/lease-vehicles",
  ADD_GEOFENCE:    "/lease/vehicles/add-geofence",
  VIEW_GEOFENCES:  "/lease/vehicles/view-geofences",
  VEHICLE_STATS:   "vehicle-stats",
  PAST_RIDES:      "past-rides",
  RIDE_DETAILS:    "ride-details",

  DRIVERS:         "drivers",
  ADD_DRIVERS:     "drivers/add",

  // Driver Mobile Flow
  DRIVER_ROUTE_CHECK: "/driver-route-check",
  SELECT_BUS: "select-bus",
  SELECT_ROUTE: "select-route",
  ENTER_PIN: "enter-pin",
  NAVIGATION: "navigation",
  ROUTE_HISTORY: "/route-history",

  REPORTS:              "reports",
  // Analytics Routes
  MOTOR_TEMPERATURE:    "motor-temperature",
  MOTOR_STATUS:         "motor-status",
  AVERAGE_RUNNING:      "average-running",
  BATTERY_TEMPERATURE:  "battery-temperature",
  BATTERY_VOLTAGE:      "battery-voltage",
  CHARGE_CYCLE:         "charge-cycle",
  THROTTLE_PERCENT:     "throttle-percent",
  BATTERY_HEALTH:       "battery-health",

  // Drivers
  DRIVER_STATS:         "driver-stats",

  // LEASE
  PAYMENTS:         "payments",

  // Wallet
  TRANSACTION_DETAILS: "transaction-details",

  // routes for dealers
  SHOW_DEALERS: "/show-dealers",
  ADD_DEALER: "/show-dealers/add-dealer",
  SPECIFIC_DEALER: "dealer-profile",
  EDIT_DEALER: "edit-dealer",

  // routes for inventory
  MANAGE_INVENTORY: "/manage-inventory",
  DEVICES: "devices",
  SPECIFIC_DEVICE: "specific-device",
  MAP_TO_VEHICLE: "map-to-vehicle",
  EDIT_VEHICLE_DETAILS: "edit-vehicle-details",

  // Dealers / Client Management
  DEALERS_OVERVIEW: "/dealers-overview",
  ORDER_DETAIL: "order-detail",
  ORDERS_OVERVIEW: "/orders-overview",
  INVENTORY_OVERVIEW: "/inventory-overview",
  INSTALLATION_VIDEO: "/installation-video",
  OEM_DEALERS:"oem-dealers",
  SHIPPING_DETAILS: "shipping-details",
  SHIPMENT_STATUS: "shipment-status",
  SHIPMENT_OVERVIEW: "/shipment-overview",

  //  User Login
  LIVE_TRACKING: "/live-tracking",
  // STATISTICS: "/statistics",
  SET_ALERTS: "/set-alerts",

  ALL_VEHICLE_STATS: "/all-vehicle-stats",
  SINGLE_VEHICLE_STATS: "single-vehicle-stats",
  ALERTS: "alerts",
  ADD_GEOFENCE_ALERT: "add-geofence-alert",
  ADD_OVERSPEED_ALERT: "add-over-speed-alert",
  SET_ROUTES: "/set-routes",
  VIEW_ROUTES: "/view-routes",
  ROUTES_SUMMARY: "/routes-summary",
  ARCHIVED_ROUTES: "/archived-routes",
  VIEW_STATS: "view-stats",

  // BULK OPERATION
  BULK_OPERATIONS: "/bulk-operations",
  NEW_BULK_OPERATION: "/new-bulk-operation",
  OPERATION_SUMMARY: "/operation-summary",

  // SUB USER PATHS
  SUB_USERS: "/sub-users",
  CREATE_SUB_USER: "create-subUser",
  SUB_USER_DETS: "sub-user-details",
  ASSIGN_VEHICLES: "assign-vehicles",

  // Contact Sticker
  CONTACT_STICKER: "contact-sticker",
  DRIVER_MANAGEMENT: "/driver-management",
  DRIVER_MANAGEMENT_ADD: "add-driver",
  DRIVER_SUMMARY: "summary",
  DRIVER_TRIPS: "trips",
  DRIVER_RIDE_DETAILS: "ride-details",
  CS_ACT_PAGE: "activation-page",
  CALL_OWNER: "call-owner",
  SHARING_STOPED: "sharing-stopped",
  VEHICLE_ACTIVITY: "/vehicle-activity",
  LANDING_PAGE: "/landing-page",
  SECURED_CALL_RSN: "/secured-call-rsn",
  PROFILE_PAGE: "/user-profile",
  STICKER_SETTINGS: "/sticker-settings",
  SCANNED_PREVIEW_PAGE: "/sc",
  CS_NOTIFICATIONS: "/notifications",
  EMERGENCY_CONTACT: "/emergency-contact",
  UPDATE_VEHICLE: "update-vehicle",

  FEATURE_AWARENESS: "/feature-awareness",
  MAP_DEVICE: "map-device",
  BULK_MAP_DEVICE: "bulk-map-device",
  DEVICE_SUBSCRIPTION: "/device-subscription",
  RENEWAL_DETAIL: "/renewal-detail",
  UPLOAD_RENEWAL_LIST: "/upload-renewal-list",

  // Plans & Warranty
  PLANS_AND_WARRANTY: "/plans-and-warranty",
  PLANS_AND_WARRANTY_DETAIL: ":vehicleId",
};

export default ROUTES;
